import React, { useState, useEffect, useContext } from "react";
import { Dialog } from "primereact";

import Loader from "../../../../Base/Components/Loader/Loader";
import { AuthContext } from "../../../../Base/Context/AuthContext/AuthContext";
import { getInformacionEmpresa } from "../../../../Base/API/Global/InformacionEmpresa/InformacionEmpresaRequest";
import { formatNumberDecimal } from "../../../../Base/Services/FormatTemplate";

import { getFirmaPersonal } from "../../../../API/Payrolls/Firmas/FirmasRequests";
import { getAutorizaciones } from "../../../../API/Compras/Autorizaciones/AutorizacionesRequest";

import pdfMake from "pdfmake/build/pdfmake";

const FormatoVacante = ({ dialogFormato, setDialogFormato, selected, setSelected }) => {

  const { userAuth } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [formato, setFormato] = useState([]);
  

  const getValoresIniciales = async (selected) => {
    setLoading(true);
    if(selected){
        const infoEmpresa = await getInformacionEmpresa()

        const auth = await getAutorizaciones()
        let cantidadFirmas = auth.filter(i=> i.IdTipo === 43).length
        let Firmas = auth.filter(i=> i.IdTipo === 43)
        let FirmasNecesarias = Firmas.map((item) => item?.IdPermisoGeneral)
    

        const IdPersonalIngenieria = selected[0]?.IdPersonalIngenieria //15
        const IdPersonalFinanzas = selected[0]?.IdPersonalFinanzas //16
        const IdPersonalRRHH = selected[0]?.IdPersonalRRHH //17
        const IdPersonalDirectorG = selected[0]?.IdPersonalDirectorG //18
        const IdPersonalDirectorA = selected[0]?.IdPersonalDirectorA //19
        const IdPersonalGerenteA = selected[0]?.IdPersonalGerenteA //20

        let FirmaIngenieria, FirmaFinanzas, FirmaRRHH, FirmaDirectoG, FirmaDirectorA, FirmaGerenteA, ImgBlanco
        
        if(IdPersonalIngenieria && FirmasNecesarias.includes(15)){
            FirmaIngenieria = await getFirmaPersonal(IdPersonalIngenieria)
        }
        if(IdPersonalFinanzas && FirmasNecesarias.includes(16)){
            FirmaFinanzas = await getFirmaPersonal(IdPersonalFinanzas)
        }
        if(IdPersonalRRHH && FirmasNecesarias.includes(17)){
            FirmaRRHH = await getFirmaPersonal(IdPersonalRRHH)
        }
        if(IdPersonalDirectorG && FirmasNecesarias.includes(18)){
            FirmaDirectoG = await getFirmaPersonal(IdPersonalDirectorG)
        }
        if(IdPersonalDirectorA && FirmasNecesarias.includes(19)){
            FirmaDirectorA = await getFirmaPersonal(IdPersonalDirectorA)
        }
        if(IdPersonalGerenteA && FirmasNecesarias.includes(20)){
            FirmaGerenteA = await getFirmaPersonal(IdPersonalGerenteA)
        }

        ImgBlanco = await getFirmaPersonal('111')

        GenerarFormato(selected[0], infoEmpresa[0], FirmaIngenieria, FirmaFinanzas, FirmaRRHH, FirmaDirectoG, FirmaDirectorA, FirmaGerenteA, ImgBlanco, FirmasNecesarias)
    }
    setLoading(false);
  };

  const tablaLayout = {
    hLineWidth: function (i, node) {
      return i === 0 ? 0 : 0.25;
    },
    vLineWidth: function (i, node) {
      return 0.25;
    },
    hLineColor: function (i, node) {
      return "black"; 
    },
    vLineColor: function (i, node) {
      return "black"; 
    },
  };


  const GenerarFormato = (data, infoEmpresa, FirmaIngenieria, FirmaFinanzas, FirmaRRHH, FirmaDirectoG, FirmaDirectorA, FirmaGerenteA, ImgBlanco, FirmasNecesarias) => {
    setLoading(true)
    const docDefinition = {
        pageSize: "LETTER",
        pageOrientation: "portrait",
        pageMargins: [40, 81, 40, 70],

        header: function (currentPage, pageCount, pageSize) {
            return {
                table: {
                    widths: ['30%', '70%'], 
                    body: [
                        [
                            {
                                image: `${infoEmpresa?.LogoPrimarioB64}`,
                                width: 180,
                                margin: [20, -8, 0, 0] 
                            },
                            {
                                text: `${data?.NoVacante || ''}`,
                                margin: [220, 30, 0, 0],
                                style: 'titulo',
                            },
                        ]
                    ]
                },
                layout: 'noBorders' 
            }
        },

        footer: (currentPage, pageCount) => {
            return {
                margin: [40, 15, 40, 0],
                table: {
                    widths: ['28%','42%', '30%'],
                    body: [
                        [
                            {
                                text: 'Fecha Impresión: ' + new Date().toLocaleString('es-ES'),
                                style: 'footer',
                            },
                            {
                                text: `Pagina ${currentPage} / ${pageCount}`,
                                style: 'footerPag',
                            },
                            {
                                text: `FR-RH05`,
                                style: 'footerDoc',
                            },
                        ],
                    ],
                },
                layout: {
                    defaultBorder: false,
                },
            };
        },
        

        content: [
            // A
            {
                table: {
                    widths: ["100%"],
                    body: [
                        [
                            {
                                text: `Fecha: ${(data?.DateCreateStr).toLocaleString('es-ES')}` ,
                                style: 'header',
                                border: [false, false, false, false]
                            },
                        ],
                        [
                            {
                                text: `A) INFORMACION DE QUE SE REQUIERE PARA CONTRATACION:` ,
                                style: 'enunciado',
                                border: [false, false, false, false]
                            },
                        ],

                    ],
                },
                layout: tablaLayout,
            },

            {
                margin: [0,5,0,0],
                table: {
                    widths: ["15%", '45%', '10%', '30%'],
                    body: [
                        [
                            {
                                text: `Título del puesto:` ,
                                style: 'enunciadoSimple',
                                border: [false, false, false, false],
                            },
                            {
                                text: `${data?.Posicion || ''}` ,
                                border: [false, false, false, true],
                                style: 'informacion',
                            },
                            {
                                text: `Sección` ,
                                style: 'enunciadoSimple',
                                border: [false, false, false, false],
                            },
                            {
                                text: `${data?.TipoTrabajo || ''}` ,
                                border: [false, false, false, true],
                                style: 'informacion',
                            },
                        ],
                        [
                            {
                                text: `Departamento:` ,
                                style: 'enunciadoSimple',
                                border: [false, false, false, false],
                            },
                            {
                                text: `${data?.Area || ''}` ,
                                style: 'informacion',
                                border: [false, false, false, true],
                            },
                            {
                                text: `No. Plazas:` ,
                                style: 'enunciadoSimple',
                                border: [false, false, false, false],
                            },
                            {
                                text: `${formatNumberDecimal(data?.NoPlazas) || ''}` ,
                                style: 'informacion',
                                border: [false, false, false, true],
                            },
                        ],
                    ],
                },
            },

            {
                margin: [0,20,0,0],
                table: {
                    widths: ["23%", '77%'],
                    body: [
                        [
                            {
                                text: `Objetivos de Contratación:` ,
                                style: 'enunciadoSimple',
                                // border: [false, false, false, false],
                            },
                            {
                                text: `${data?.Objetivo || ''}` ,
                                // border: [false, false, false, true],
                                style: 'informacion',
                            },
                        ],
                    ],
                },
            },
            {
                text: 'Perfil del Puesto',
                style: 'textoGeneral',
                margin: [5,10,0,0],
            },
            {
                margin: [0,10,0,0],
                table: {
                    widths: ["20%", '80%'],
                    body: [
                        [
                            {
                                text: `Experiencia:` ,
                                style: 'enunciadoSimple',
                                // border: [false, false, false, true],
                            },
                            {
                                text: `${data?.Conocimiento || ''}` ,
                                // border: [false, false, false, true],
                                style: 'informacion',
                            },
                        ],
                        [
                            {
                                text: `Educación Requerida:` ,
                                style: 'enunciadoSimple',
                                // border: [false, false, false, false],
                            },
                            {
                                text: `${data?.Educacion || ''}` ,
                                // border: [false, false, false, true],
                                style: 'informacion',
                            },
                        ],
                        [
                            {
                                text: `Otros:` ,
                                style: 'enunciadoSimple',
                                // border: [false, false, false, false],
                            },
                            {
                                text: `${data?.ComentarioPerfil || ''}` ,
                                // border: [false, false, false, true],
                                style: 'informacion',
                            },
                        ],
                    ],
                },
            },

            // B
            {
                margin: [0,20,0,0],
                table: {
                    widths: ["35%", "65%"],
                    body: [
                        [
                            {
                                text: `B) CRITERIOS DE CONTRATACION:` ,
                                style: 'enunciado',
                                border: [false, false, false, false]
                            },
                            {
                                text: `${data?.CriteriosContratacion || ''}` ,
                                style: 'informacion',
                                border: [false, false, false, false]
                            },
                        ],

                    ],
                },
            },
            {
                margin: [0,10,0,0],
                table: {
                    widths: ['10%', '2%', '15%', '2%', '15%', '2%'],
                    body: [
                        [
                            {
                                text: `Reemplazo: ` ,
                                style: 'header2',
                                border: [false, false, false, false]
                            },
                            {
                                text: `${data?.Reemplazo === true ? 'X' : ''}` ,
                                style: 'header',
                            },
                            {
                                text: `Sustitución: ` ,
                                style: 'header',
                                border: [false, false, false, false],
                            },
                            {
                                text: `${data?.Sustitucion === true ? 'X' : ''}` ,
                                style: 'header',
                            },
                            {
                                text: `Nueva Plaza: ` ,
                                style: 'header',
                                border: [false, false, false, false],
                            },
                            {
                                text: `${data?.NuevaPlaza === true ? 'X' : ''}` ,
                                style: 'header',
                            },
                        ],


                    ],
                },
            },

            // C
            {
                margin: [0,20,0,0],
                table: {
                    widths: ["30%", '10%', '2%', '10%', '2%'],
                    body: [
                        [
                            {
                                text: `C) EN PRESUPUESTO:` ,
                                style: 'enunciado',
                                border: [false, false, false, false]
                            },
                            {
                                text: `Sí` ,
                                style: 'header',
                                border: [false, false, false, false]
                            },
                            {
                                text: `${data?.EnPresupuesto === true ? 'X' : ''}` ,
                                style: 'header',
                                border: [true, true, true, true]
                            },
                            {
                                text: `No` ,
                                style: 'header',
                                border: [false, false, false, false]
                            },
                            {
                                text: `${data?.EnPresupuesto === true ? '' : 'X'}` ,
                                style: 'header',
                                border: [true, true, true, true]
                            },
                        ],

                    ],
                },
            },

            //FIRMAS
            {
                margin: [0,0,0,0],
                table: {
                    widths: ["30%", '5%', '30%', '5%', '30%'],
                    body: [
                        [
                            FirmaIngenieria ?
                            {
                                image: "data:image/png;base64," + FirmaIngenieria,
                                width: 150,
                                height: 120,
                                margin: [0, 0, -50, -30],
                                border: [false, false, false, false]
                            } : 
                            {
                                image: "data:image/png;base64," + ImgBlanco,
                                width: 150,
                                height: 120,
                                margin: [0, 0, -50, -30],
                                border: [false, false, false, false]
                            },
                            {
                                text: `` ,
                                border: [false, false, false, false]
                            },
                            FirmaFinanzas ?
                            {
                                image: "data:image/png;base64," + FirmaFinanzas,
                                width: 150,
                                height: 120,
                                margin: [0, 0, -50, -30],
                                border: [false, false, false, false]
                            } : 
                            {
                                image: "data:image/png;base64," + ImgBlanco,
                                width: 150,
                                height: 120,
                                margin: [0, 0, -50, -30],
                                border: [false, false, false, false]
                            },
                            {
                                text: `` ,
                                border: [false, false, false, false]
                            },
                            FirmaRRHH ?
                            {
                                image: "data:image/png;base64," + FirmaRRHH,
                                width: 150,
                                height: 120,
                                margin: [0, 0, -50, -30],
                                border: [false, false, false, false]
                            } : 
                            {
                                image: "data:image/png;base64," + ImgBlanco,
                                width: 150,
                                height: 120,
                                margin: [0, 0, -50, -30],
                                border: [false, false, false, false]
                            },
                        ],
                        [
                            FirmasNecesarias.includes(15) ? 
                            {
                                text: `Ingeniería de Procesos \n${data?.UserNameIngenieria || ''}` ,
                                style: 'firmas',
                                border: [false, true, false, false]
                            } : 
                            {
                                text: `` ,
                                border: [false, false, false, false]
                            },
                            {
                                text: `` ,
                                border: [false, false, false, false]
                            },
                            FirmasNecesarias.includes(16) ?
                            {
                                text: `Finanzas \n${data?.UserNameFinanzas || ''}` ,
                                style: 'firmas',
                                border: [false, true, false, false]
                            } : 
                            {
                                text: `` ,
                                border: [false, false, false, false]
                            },
                            {
                                text: `` ,
                                border: [false, false, false, false]
                            },
                            FirmasNecesarias.includes(17) ?
                            {
                                text: `Recursos Humanos \n${data?.UserNameRRHH || ''}` ,
                                style: 'firmas',
                                border: [false, true, false, false]
                            } : 
                            {
                                text: `` ,
                                border: [false, false, false, false]
                            },
                        ],
                    ],
                },
            },
            {
                margin: [0,0,0,0],
                table: {
                    widths: ["30%", '5%', '30%', '5%', '30%'],
                    body: [
                        [
                            FirmaDirectoG ?
                            {
                                image: "data:image/png;base64," + FirmaDirectoG,
                                width: 150,
                                height: 120,
                                margin: [0, 0, -50, -30],
                                border: [false, false, false, false]
                            } : 
                            {
                                image: "data:image/png;base64," + ImgBlanco,
                                width: 150,
                                height: 120,
                                margin: [0, 0, -50, -30],
                                border: [false, false, false, false]
                            },
                            {
                                text: `` ,
                                border: [false, false, false, false]
                            },
                            FirmaDirectorA ?
                            {
                                image: "data:image/png;base64," + FirmaDirectorA,
                                width: 150,
                                height: 120,
                                margin: [0, 0, -50, -30],
                                border: [false, false, false, false]
                            } :
                            {
                                image: "data:image/png;base64," + ImgBlanco,
                                width: 150,
                                height: 120,
                                margin: [0, 0, -50, -30],
                                border: [false, false, false, false]
                            },
                            {
                                text: `` ,
                                border: [false, false, false, false]
                            },
                            FirmaGerenteA ?
                            {
                                image: "data:image/png;base64," + FirmaGerenteA,
                                width: 150,
                                height: 120,
                                margin: [0, 0, -50, -30],
                                border: [false, false, false, false]
                            } : 
                            {
                                image: "data:image/png;base64," + ImgBlanco,
                                width: 150,
                                height: 120,
                                margin: [0, 0, -50, -30],
                                border: [false, false, false, false]
                            },
                        ],
                        [
                            FirmasNecesarias.includes(18) ? 
                            {
                                text: `Director General \n${data?.UserNameDirectorG || ''}` ,
                                style: 'firmas',
                                border: [false, true, false, false]
                            } : 
                            {
                                text: `` ,
                                border: [false, false, false, false]
                            },
                            {
                                text: `` ,
                                border: [false, false, false, false]
                            },
                            FirmasNecesarias.includes(19) ?
                            {
                                text: `Director Area \n${data?.UserNameDirectorA || ''}` ,
                                style: 'firmas',
                                border: [false, true, false, false]
                            } :
                            {
                                text: `` ,
                                border: [false, false, false, false]
                            },
                            {
                                text: `` ,
                                border: [false, false, false, false]
                            },
                            FirmasNecesarias.includes(20) ?
                            {
                                text: `Gerente Area \n${data?.UserNameGerenteA || ''}` ,
                                style: 'firmas',
                                border: [false, true, false, false]
                            } : 
                            {
                                text: `` ,
                                border: [false, false, false, false]
                            },
                        ],
                    ],
                },
            },

        ],
        

        styles: {
            titulo: {
              fontSize: 13,
              bold: true,
              alignment: "center",
            },
            header: {
                fontSize: 9,
                alignment: "right",
            },
            header2: {
                fontSize: 9,
                alignment: "left",
            },
            enunciado: {
                fontSize: 11,
                bold: true,
                alignment: "justify",
            },
            firmas: {
                fontSize: 9,
                alignment: "center",
            },
            enunciadoSimple: {
                fontSize: 9,
                bold: true,
                alignment: "left",
            },
            informacion: {
                fontSize: 9,
                alignment: "left",
            },
            textoGeneral: {
                fontSize: 10,
                bold: true,
                alignment: "justify",
            },
            footer: {
                fontSize: 8,
                alignment: "justify",
            },
            footerDoc: {
                fontSize: 11,
                bold: true,
                alignment: "right",
            },
            footerPag: {
                fontSize: 8,
                alignment: "center",
            },
        },
    }

    const doc = pdfMake.createPdf(docDefinition);

    doc.getDataUrl((url) =>{ setFormato(url) })
    setLoading(false)
  }

  const onHide = () => {
    setDialogFormato(false);
    setSelected([])
  };

  useEffect(() => {
    if (dialogFormato) {
      getValoresIniciales(selected);
    }
  }, [dialogFormato]);

  return (
    <div>
      <Dialog
        visible={dialogFormato}
        onHide={onHide}
        style={{ width: "63vw", height: "85vh" }}
      >
        <Loader loading={loading} querySelector='FormatoDialog' />
        <div id="FormatoDialog">
          {!loading && formato && (
            <iframe
              src={formato}
              style={{ width: "60vw", height: "75vh", border: "1px solid #ccc" }}
              id="foo"
            />
          )}
        </div>
      </Dialog>
      
    </div>
  );
};

export default FormatoVacante;
